import React from 'react'

import { COMMENT_STATUSES } from '../constants'

type CommentStatusType = 'open' | 'resolved'

interface CommentStatusProps {
  status: CommentStatusType
}

const STATUS_STYLES: Record<
  CommentStatusType,
  { bg: string; text: string; border: string }
> = {
  open: {
    bg: 'bg-blue-50',
    text: 'text-blue-700',
    border: 'border-blue-200',
  },
  resolved: {
    bg: 'bg-success-50',
    text: 'text-success-700',
    border: 'border-success-200',
  },
}

export const CommentStatus: React.FC<CommentStatusProps> = ({ status }) => {
  const statusLabel = COMMENT_STATUSES[status]
  const styles = STATUS_STYLES[status]

  if (!styles || !statusLabel) {
    return <span>-</span>
  }

  return (
    <span
      className={`ml-1 inline-flex items-center px-2 py-[2px] rounded-full border-solid border ${styles.bg} ${styles.text} ${styles.border} text-xs font-medium`}
    >
      {statusLabel}
    </span>
  )
}
